import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { useLocation } from "@reach/router";
import { useStaticQuery, graphql } from "gatsby";

// Importy faviconów

const SEO = ({ title, description, image, article, noImg }) => {
  const { pathname } = useLocation();
  const { site } = useStaticQuery(query);
  const {
    defaultTitle,
    defaultDescription,
    siteUrl,
    defaultImage,
    // twitterUsername,
  } = site.siteMetadata;
  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: `${image || defaultImage}`,
    url: `${siteUrl}${pathname}`,
  };
  return (
    <Helmet htmlAttributes={{ lang: "pl" }} title={seo.title}>
      <title>{seo.title}</title>

      <link rel="icon" type="image/svg+xml" href="/favicon/favicon.svg" />
      <link rel="shortcut icon" href="/favicon/favicon.ico" />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="/favicon/apple-touch-icon.png"
      />
      <link rel="manifest" href="/favicon/site.webmanifest" />

      <link
        rel="mask-icon"
        href="data:image/svg+xml;base64,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"
        color="#000000"
      ></link>

      {/* Dla Windows */}
      {/* <meta name="msapplication-TileImage" content={androidIcon192} />
      <meta name="msapplication-TileColor" content="#000000" />

      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1"
      /> */}

      {seo.url && <meta property="og:url" content={seo.url} />}
      {(article ? true : null) && <meta property="og:type" content="article" />}
      {seo.title && <meta property="og:title" content={seo.title} />}
      {seo.description && (
        <meta property="og:description" content={seo.description} />
      )}
      {noImg
        ? null
        : seo.image && (
            <meta property="og:image:secure_url" content={seo.image} />
          )}
      {seo.image && <meta property="og:image" content={seo.image} />}

      {/* <meta name="twitter:card" content="summary_large_image" />
      {twitterUsername && (
        <meta name="twitter:creator" content={twitterUsername} /> */}
      {seo.title && <meta name="twitter:title" content={seo.title} />}
      {seo.description && (
        <meta name="twitter:description" content={seo.description} />
      )}
      {seo.image && <meta name="twitter:image" content={seo.image} />}
    </Helmet>
  );
};
export default SEO;
SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  article: PropTypes.bool,
};
SEO.defaultProps = {
  title: null,
  description: null,
  image: null,
  article: false,
};
const query = graphql`
  query SEO {
    site {
      siteMetadata {
        defaultTitle: title
        defaultDescription: description
        siteUrl: url
        defaultImage: img
      }
    }
  }
`;
